import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import SideBar from "../SideBar";
import style from './ExamResult.module.css'
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { useParams } from "react-router-dom";
import { jsPDF } from 'jspdf';
import moment from "moment";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";


const TPTExamResult = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
    const contentRef = React.useRef();
    const params = useParams()
    const [result,setResult]=useState([])
    console.log(result)

    const downloadPDF = () => {
      const doc = new jsPDF();
  
      // Get the content element's width and height
      const content = contentRef.current;
      const contentWidth = content.offsetWidth;
      const contentHeight = content.offsetHeight;
  
      // Get the width and height of the PDF page
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
  
      // Set margins (for example, 10px on each side)
      const margin = 10;
  
      // Calculate scale factor
      const scaleX = (pageWidth - 2 * margin) / contentWidth; // Consider margins in width
      const scaleY = (pageHeight - 2 * margin) / contentHeight; // Consider margins in height
      const scale = Math.min(scaleX, scaleY); // Ensure content fits within page
  
      // Calculate the starting x and y position to center the content (with margins)
      const x = margin;
      const y = margin;
  
      // Capture the content as a PDF
      doc.html(content, {
          callback: function (doc) {
              doc.save(`${result.examName}.pdf`);
          },
          x: x,
          y: y,
          html2canvas: {
              scale: scale, // Apply scaling
              useCORS: true, // Use CORS to handle cross-origin images
          },
      });
  };
  
    const getExamResult = () => {
        axios.get(`${baseUrl}/exam/result?examId=${params.id}`)
            .then(res => setResult(res.data))
            .catch(e => console.log(e))
    }
    useEffect(() => {
        getExamResult()
    }, [])

    return (
      <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
        <aside
          className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
        >
          <SideBar />
        </aside>

        <main className={styles.mainContent}>
          <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
          <nav aria-label="breadcrumb" >
            <ol className="breadcrumb">
              <div className="d-flex flex-grow-1">
                <li className="breadcrumb-item">
                  <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to='/admin/exams' className="text-decoration-none">All Exams</Link>
                </li>
                <li className="breadcrumb-item">
                  Result
                </li>
              </div>
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  href=""
                  role="button"
                  aria-expanded="false"
                >
                  Welcome, {user.name}
                  <i className="ml-2 fa fa-angle-down"></i>
                </span>
                <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                  <li>
                    <span className="dropdown-item" onClick={logout}>
                      Logout
                    </span>
                  </li>
                </ul>
              </li>
            </ol>
          </nav>
          <button className="btn btn-success btn-sm mb-2" onClick={downloadPDF}>Download</button>
          <div 
            ref={contentRef}
            className="container"
            style={{ backgroundColor: "white", padding: "40px" }}
          >
            <div className="justify-content-center d-flex">
              <img src='/assets/images/monoarclogo.jpeg' width='230px' alt='logo' />
            </div>
            <h4 className="mb-4 text-center">{result.examName} Results</h4>
            <div className="d-flex container">
              <div className="d-flex flex-grow-1">
                <span className="fw-bold p-2">Class : {result.className?.substring(6)}</span>
              </div>
              <div>
                <span className="fw-bold">Date : {moment(result.startDate).format('DD MMMM YYYY')}</span><br></br>
                <span className="fw-bold">Marks : {(result.totalQuestions)*4}</span>
              </div>
            </div>
            <div style={{overflowX:"scroll"}}>
              <table className={`${style.table}`}>
                <thead style={{backgroundColor:'#af6adbd9',color:'white'}}>
                  <tr>
                    <th rowSpan="2" style={{minWidth:'100px'}}>Student Name</th>
                    <th>Question Analysis<br></br><span className={`${style.qaSpan}`}>( correct | incorrect | left )</span></th>
                    <th rowSpan="2" style={{minWidth:'50px'}}>Total Marks<br></br><span style={{fontWeight:'400'}}>( {(result.totalQuestions)*4} )</span></th>
                  </tr>
                </thead>
       
                <tbody>
                {
                  result.results&&
                  result.results.map((r,i)=>
                    <tr key={i}>
                      <td>({i+1}) {r.studentName}</td>
                      <td>{r.exams[0].correct} | {r.exams[0].incorrect} | {r.exams[0].unattemptedQuestions}</td>
                      <td>{r.exams[0].score}</td>
                    </tr>
                  )
                }
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    );
};

export default TPTExamResult;
